import { StyleSheet } from "react-native";
import { Theme } from "../theme-provider";

export const statusReportSliderStyle = (theme: Theme) => StyleSheet.create({
    container: {
        marginBottom: theme.spacing.double,
    },

    reportCard: {
        width: 200,
        height: 120,
        marginRight: theme.spacing.standard,
        borderRadius: theme.borderRadius.standard,
        overflow: 'hidden',
        position: 'relative',
    },

    backgroundImage: {
        width: '100%',
        height: '100%',
        resizeMode: 'cover',
    },

    placeholderBackground: {
        width: '100%',
        height: '100%',
        backgroundColor: theme.color.listBackground,
    },

    overlay: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        justifyContent: 'flex-end',
        padding: theme.spacing.standard,
    },

    contentContainer: {
        flexDirection: 'column',
        alignItems: 'flex-start',
    },

    starsContainer: {
        flexDirection: 'row',
        marginBottom: theme.spacing.half,
    },

    star: {
        fontSize: 18,
        color: '#666',
        marginRight: 2,
    },

    starFilled: {
        color: '#FFD700',
    },

    date: {
        fontSize: theme.fontSize.small,
        color: '#fff',
        fontWeight: '600',
        textShadowColor: 'rgba(0, 0, 0, 0.75)',
        textShadowOffset: { width: 0, height: 1 },
        textShadowRadius: 2,
    },
});
